import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bab1d97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "供应商",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('name', $event, $event))),
                  style: {"width":"200px"},
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.phone,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.phone) = $event)),
                  onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('phone', $event, $event))),
                  style: {"width":"200px"},
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "公司名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.company_name,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.company_name) = $event)),
                  onSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch('company_name', $event, $event))),
                  style: {"width":"200px"},
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, null, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}